import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router";
import { chooseLang } from "../common/chooseLang";
import { getConfig, getTemplates } from "../ApiCalls";
import Loader from "../common/Loader";
import { getMobileQuery } from "../common/utils";
import SliderOneByOne from "./SliderOneByOne";

const WrapperStyled = styled.div`
    max-width: 1050px;
    margin: auto;
    min-height: 430px;
    height: 430px;
    overflow: auto;

    @media (max-width: 1049px) {
        width: 100%;
        max-width: 100%;
    }

    @media (max-width: 600px) {
        height: 460px;
        min-height: 460px;
    }
`;

const LoaderStyled = styled.div`
    text-align: center;
    margin-top: 20px;
`;

const Slider = () => {
    const location = useLocation();
    const innerWidth = getMobileQuery();
    const queryParameters = new URLSearchParams(location.search);
    const lang = queryParameters.get("language") || "he";
    const clientId = queryParameters.get("clientId") || "64d491633684ef0d32edb473";

    const [loading, setLoading] = useState(true);
    const [templates, s_templates] = useState([]);
    const [config, s_config] = useState(null);

    const itemVariants = {
        initial: { opacity: 0, scale: 0 },
        animate: { opacity: 1, scale: 1 },
    };
    const getItemAnimation = (delay, isBg) => ({
        initial: "initial",
        animate: "animate",
        variants: itemVariants,
        transition: { duration: 0.4, delay },
    });

    const langData = chooseLang(lang);

    let maxInRow = 4;

    if (innerWidth < 1000) {
        maxInRow = 3;
    }

    if (innerWidth < 699) {
        maxInRow = 2;
    }

    useEffect(() => {
        if (clientId) {
            getConfig(lang, clientId).then(data => {
                s_config(data);
            }).catch(e => {
                console.log("e", e);
            });
        }
    }, []);

    useEffect(() => {
        getTemplates(lang, clientId)
            .then(data => {
                data.forEach((item, index) => {
                   const randomTrueOrFalse = Math.random() >= 0.5;
                   if(randomTrueOrFalse) {
                       item.imageUrl = item.imageUrlFemale;
                   }else {
                       item.imageUrl = item.imageUrlMale;
                   }
                });
                s_templates(data);
                setLoading(false);
            })
            .catch(e => {
                console.log(e);
            });
    }, []);

    useEffect(() => {
        if (lang === "he" || lang === "ar") {
            document.dir = "rtl";
            document.title = langData?.general?.pageTitle;
        } else {
            document.dir = "ltr";
            document.title = langData?.general?.pageTitle;
        }
        document.documentElement.lang = lang;
    }, [lang]);

    return (
        <WrapperStyled className={ `container lang-${ lang }` }>
            { loading && (
                <LoaderStyled>
                    <Loader />
                </LoaderStyled>
            ) }
            { !loading && (
                <SliderOneByOne
                    config={config}
                    items={ templates }
                    lang={ lang }
                    langData={ langData }
                    maxRows={ 1 }
                    maxInRow={ maxInRow }
                    getItemAnimation={ getItemAnimation }
                />
            ) }
        </WrapperStyled>
    );
};

export default Slider;
